import React from "react";

const Membership = () => {
  return (
    <div className="pt-5">
      <h4>Membership Details</h4>
      <p>Here are the details of your membership...</p>
      <ul className="list-group">
        <li className="list-group-item">Membership Type: Premium</li>
        <li className="list-group-item">Status: Active</li>
        <li className="list-group-item">Renewal Date: 12th Dec 2025</li>
        <li className="list-group-item">Price: $99/year</li>
      </ul>
    </div>
  );
};

export default Membership;
